/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvcGFnZXMvYWRtaW4vaWNvbnRhY3Qvc2V0dGluZy9jb250YWN0L2dyb3VwL2dyb3VwLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvcXVhbmhvYW5nL3plbmlmeS9yZXBvcy9jbGllbnQtZmluYWwvc3JjL2FwcC9wYWdlcy9hZG1pbi9pY29udGFjdC9zZXR0aW5nL2NvbnRhY3QvZ3JvdXAvZ3JvdXAuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/pages/admin/icontact/setting/contact/group/group.component.css.shim.ngstyle.ts